import axios from 'axios';
export default {
	generateCaptcha() {
		return axios.get('/otpgroup/donate/init');
	},
	loadFormData(transactionId) {
		return axios.get('/otpgroup/donate', { params: { transactionId } });
	},
	submit(data) {
		return axios.post('/otpgroup/donate', data);
	}
};
